
export function DetermineIfChristmasTime() {
  const today = new Date(Date.now());
  const isLateDecember = (today.getMonth() == 11 && today.getDate() > 10);
  const isEarlyJanuary = (today.getMonth() == 0 && today.getDate() < 15);
  return (isLateDecember || isEarlyJanuary);
}

export function DetermineIfEasterTime() {
  let isEasterTime = false;
  // Paschal full moon; Catholic Easter falls on the first Sunday after this date;
  // Orthodox - some ~7-14 days later; we strive to capture both
  let fullMoonDay, fullMoonMonth;
  // keep Easter theme on the site for this many days after the Paschal full moon
  const easterPeriodDurationDays = 20;
  const today = new Date(Date.now());
  const thisYear = today.getFullYear();
  switch (thisYear) {
    case 2023:
      fullMoonDay = 5;
      fullMoonMonth = 4 - 1;
      break;
    case 2024:
      fullMoonDay = 25;
      fullMoonMonth = 3 - 1;
      break;
    case 2025:
      fullMoonDay = 13;
      fullMoonMonth = 4 - 1;
      break;
    default:
      fullMoonDay = null;
      fullMoonMonth = null;
      break;
  }

  // .getMonth() returns 0-11; but Date() expects 1-12. /* Thanks, JS. WTAF? */
  const maxDaysInMonth = new Date(thisYear, fullMoonMonth + 1, 0).getDate();
  if (fullMoonDay + easterPeriodDurationDays > maxDaysInMonth) {
    const durationInNextMonthDays = (fullMoonDay + easterPeriodDurationDays) % maxDaysInMonth;
    const isFullMoonMonth = (today.getMonth() == fullMoonMonth && today.getDate() >= fullMoonDay);
    const isNextMonth = (today.getMonth() == fullMoonMonth + 1 && today.getDate() <= durationInNextMonthDays);
    isEasterTime = (isFullMoonMonth || isNextMonth);
    /*
    console.log({
      maxDaysInFullMoonMonth: maxDaysInMonth,
      daysInNextMonthToReseve: durationInNextMonthDays,
      isFullMoonMonth: isFullMoonMonth,
      isNextMonth: isNextMonth
    });
    */
  } else {
    isEasterTime = (today.getMonth() == fullMoonMonth && today.getDate() >= fullMoonDay &&
      today.getDate() <= fullMoonDay + easterPeriodDurationDays);
  }

  return isEasterTime;
}
